import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remote-access',
  templateUrl: './remote-access.component.html',
  styleUrls: ['./remote-access.component.css']
})
export class RemoteAccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
